function HomepageElectronIcon() {
	return (
		<svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M35.4799 17.7501C38.6942 17.7501 41.2999 15.1444 41.2999 11.9301C41.2999 8.71581 38.6942 6.11011 35.4799 6.11011C32.2656 6.11011 29.6599 8.71581 29.6599 11.9301C29.6599 15.1444 32.2656 17.7501 35.4799 17.7501Z"
				stroke="#3A7DE4"
				strokeWidth="3"
			/>
			<path
				d="M54.59 37.92C57.8043 37.92 60.41 35.3143 60.41 32.1C60.41 28.8857 57.8043 26.28 54.59 26.28C51.3757 26.28 48.77 28.8857 48.77 32.1C48.77 35.3143 51.3757 37.92 54.59 37.92Z"
				stroke="#3A7DE4"
				strokeWidth="3"
			/>
			<path
				d="M35.4799 56.89C38.6942 56.89 41.2999 54.2843 41.2999 51.07C41.2999 47.8557 38.6942 45.25 35.4799 45.25C32.2656 45.25 29.6599 47.8557 29.6599 51.07C29.6599 54.2843 32.2656 56.89 35.4799 56.89Z"
				stroke="#3A7DE4"
				strokeWidth="3"
			/>
			<path
				d="M16.12 48.35C19.3343 48.35 21.94 45.7443 21.94 42.53C21.94 39.3157 19.3343 36.71 16.12 36.71C12.9058 36.71 10.3 39.3157 10.3 42.53C10.3 45.7443 12.9058 48.35 16.12 48.35Z"
				stroke="#3A7DE4"
				strokeWidth="3"
			/>
			<path
				d="M16.12 25.59C19.3343 25.59 21.94 22.9842 21.94 19.77C21.94 16.5557 19.3343 13.95 16.12 13.95C12.9058 13.95 10.3 16.5557 10.3 19.77C10.3 22.9842 12.9058 25.59 16.12 25.59Z"
				stroke="#3A7DE4"
				strokeWidth="3"
			/>
			<path
				d="M35.47 34.4701C38.0658 34.4701 40.17 32.3658 40.17 29.7701C40.17 27.1743 38.0658 25.0701 35.47 25.0701C32.8743 25.0701 30.77 27.1743 30.77 29.7701C30.77 32.3658 32.8743 34.4701 35.47 34.4701Z"
				stroke="#3A7DE4"
				strokeWidth="3"
			/>
			<path d="M21.1299 16.7999L29.8599 13.4299" stroke="#3A7DE4" strokeWidth="3" />
			<path d="M39.5601 16.0901L50.4401 28.0201" stroke="#3A7DE4" strokeWidth="3" />
			<path d="M51.0299 36.7L39.6299 46.99" stroke="#3A7DE4" strokeWidth="3" />
			<path d="M19.3201 24.6299L31.8701 46.5099" stroke="#3A7DE4" strokeWidth="3" />
			<path d="M21.27 45.24L29.66 49.13" stroke="#3A7DE4" strokeWidth="3" />
			<path d="M18.3 37.1301L32.33 16.8201" stroke="#3A7DE4" strokeWidth="3" />
			<path d="M21.48 22.05L31.3 27.6" stroke="#3A7DE4" strokeWidth="3" />
			<path d="M40.1799 30.3L48.7699 30.9501" stroke="#3A7DE4" strokeWidth="3" />
			<path d="M35.47 34.48L35.48 45.24" stroke="#3A7DE4" strokeWidth="3" />
		</svg>
	);
}

export { HomepageElectronIcon };
